"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3127],{

/***/ 63732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fw": function() { return /* binding */ useBadgePresets; }
/* harmony export */ });
/* unused harmony export BadgeList */
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71618);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9150);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        "px;\n  display: inline-block;\n  height: 18px;\n  line-height: 16px;\n  border-radius: ",
        "px;\n  font-weight: 500;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n        cursor: pointer;\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n                  border: 1px solid transparent;\n                  background-image: linear-gradient(\n                      ",
        ",\n                      ",
        "\n                    ),\n                    ",
        ";\n                  background-origin: border-box;\n                  background-clip: content-box, border-box;\n                "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n                  border: 1px solid ",
        ";\n                  background-color: ",
        ";\n                "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n            ",
        "\n\n            span {\n              padding: 0 ",
        "px;\n            }\n          "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n                  background-image: ",
        ";\n                "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n                  background-color: ",
        ";\n                "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n            ",
        "\n\n            span {\n              padding: 0 ",
        "px;\n            }\n          "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      color: ",
        ";\n      ",
        "\n\n      ",
        "\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  font-size: 0;\n\n  * + * {\n    margin-left: ",
        "px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var badgeCSS = function(radius, fontSize) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject(), fontSize, radius);
};
var badgeColorCSS = function(color, backgroundColor) {
    var border = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isGradient = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, isClickable = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject8(), color, isClickable && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject1()), border ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject4(), isGradient ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject2(), theme.var.white, theme.var.white, backgroundColor) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject3(), backgroundColor, theme.var.white), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xxhsmall */ .Ki.xxhsmall) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject7(), isGradient ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject5(), backgroundColor) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject6(), backgroundColor), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xxsmall */ .Ki.xxsmall));
    };
};
var Badge = function(param) {
    var className = param.className, text = param.text, color = param.color, border = param.border, backgroundColor = param.backgroundColor, onClick = param.onClick, _radius = param.radius, radius = _radius === void 0 ? chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Radius.xsmall */ .wU.xsmall : _radius, _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .FontSizes.xxsmall */ .TS.xxsmall : _fontSize;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.u)();
    var ref;
    var isGradient = (ref = backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.includes("linear-gradient")) !== null && ref !== void 0 ? ref : false;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
        css: [
            badgeCSS(radius, fontSize),
            badgeColorCSS(color !== null && color !== void 0 ? color : theme.true.white, backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.var.gray500, border, isGradient, !!onClick), 
        ],
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
            children: text
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Badge);
/** List Component */ var badgeListCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject9(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xxsmall */ .Ki.xxsmall);
var BadgeList = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("div", {
        css: badgeListCSS,
        children: children
    });
};
var useBadgePresets = function() {
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.u)();
    var presets = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            // fill
            grayFill: {
                backgroundColor: theme.var.gray400,
                color: theme.true.white
            },
            mainFill: {
                backgroundColor: theme.colors.main500,
                color: theme.true.white
            },
            blueFill: {
                backgroundColor: theme.colors.blue500,
                color: theme.true.white
            },
            pinkFill: {
                backgroundColor: theme.colors.pink500,
                color: theme.true.white
            },
            redFill: {
                backgroundColor: theme.colors.red500,
                color: theme.true.white
            },
            purpleFill: {
                backgroundColor: theme.service.violet,
                color: theme.true.white
            },
            honorFill: {
                backgroundColor: "linear-gradient(to right, #17dce4, #4db4ee)",
                color: theme.true.white
            },
            new: {
                backgroundColor: theme.colors.red500,
                color: theme.true.white
            },
            // border
            pink: {
                backgroundColor: theme.colors.pink500,
                border: true,
                color: theme.colors.pink500
            },
            yellow: {
                backgroundColor: theme.colors.yellow500,
                border: true,
                color: theme.colors.yellow500
            },
            orange: {
                backgroundColor: theme.colors.yellow700,
                border: true,
                color: theme.colors.yellow700
            },
            red: {
                backgroundColor: theme.colors.red500,
                border: true,
                color: theme.colors.red500
            },
            blue: {
                backgroundColor: theme.colors.blue500,
                border: true,
                color: theme.colors.blue500
            },
            main: {
                backgroundColor: theme.colors.main500,
                border: true,
                color: theme.colors.main500
            },
            fan: {
                backgroundColor: theme.colors.blue300,
                border: true,
                color: theme.colors.blue300
            },
            famousFill: {
                backgroundColor: theme.colors.playGra,
                color: theme.true.white
            }
        };
    }, []);
    return presets;
};


/***/ }),

/***/ 93127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useTab; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71618);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47311);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var _hooks_useMounted__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38464);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9150);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92570);
/* harmony import */ var _components_common_Badge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63732);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96964);
/* harmony import */ var _utils_localStorage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48163);
/* harmony import */ var _utils_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96261);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 8px;\n  height: 14px;\n  width: 14px;\n  text-align: center;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 4px;\n  align-self: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 8px;\n  height: 15px;\n  width: 23px;\n  text-align: center;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 4px;\n  align-self: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n        display: flex;\n\n        button {\n          flex-basis: 0;\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n      ",
        ";\n      overflow: auto;\n      white-space: nowrap;\n      z-index: 9;\n      display: inline-flex;\n      padding: ",
        "px ",
        "px ",
        "px\n        ",
        "px;\n      align-items: flex-start;\n      gap: 10px;\n\n      ",
        "\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n\n      .tab-badge {\n        height: 30px;\n        padding: ",
        "px ",
        "px;\n        display: inline-flex;\n        align-items: center;\n        border-radius: 5px;\n      }\n      .active-tab-badge {\n        border: none;\n      }\n      .unactivate-tab-badge {\n        border: 1px solid ",
        ";\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n              position: sticky;\n              top: 0;\n              ",
        "\n            "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n        display: flex;\n\n        button {\n          flex-basis: 0;\n        }\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n\n      background-color: ",
        ";\n      ",
        ";\n      overflow: auto;\n      white-space: nowrap;\n      z-index: 9;\n\n      .peek-tab {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        text-align: center;\n      }\n\n      ",
        "\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      flex-grow: 1;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n          color: ",
        ";\n          border-bottom: 2px solid ",
        ";\n          font-weight: 600;\n        "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n          color: ",
        ";\n          border-bottom: 2px solid transparent;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: ",
        "px;\n    height: 42px;\n    padding: 0 ",
        "px;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}











var badgeCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject());
var dateBadgeCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject1());
var badgeTabWrapperCSS = function(isFit, hideBorder) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject3(), theme.var.white, !hideBorder && "border-bottom: 1px solid ".concat(theme.border.light), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small, isFit && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject2()), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small, theme.var.gray200);
    };
};
var tabWrapperCSS = function(isFit, top, hideBorder, topSafeAreaMode, stickyEnabled) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject6(), stickyEnabled && (top > 0 ? (0,_styles_css__WEBPACK_IMPORTED_MODULE_5__/* .sticky */ .CA)(top) : topSafeAreaMode === "offset" ? (0,_styles_css__WEBPACK_IMPORTED_MODULE_5__/* .sticky */ .CA)(0) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject4(), (0,_styles_css__WEBPACK_IMPORTED_MODULE_5__/* .safeArea */ .BI)("top"))), theme.var.white, !hideBorder && "border-bottom: 1px solid ".concat(theme.border.light), isFit && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject5()));
    };
};
var tabCSS = function(isActive, isFit) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject10(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .FontSizes.small */ .TS.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.medium */ .Ki.medium, isFit && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject7()), isActive ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject8(), theme.var.black, theme.var.black) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject9(), theme.var.gray500));
    };
};
var Tab = function(param) {
    var className = param.className, tabs = param.tabs, activeTab = param.activeTab, _fit = param.fit, fit = _fit === void 0 ? false : _fit, _stickyAt = param.stickyAt, stickyAt = _stickyAt === void 0 ? 44 : _stickyAt, onChange = param.onChange, _hideBorder = param.hideBorder, hideBorder = _hideBorder === void 0 ? false : _hideBorder, _type = param.type, type = _type === void 0 ? "default" : _type, lastPeekTabViewDate = param.lastPeekTabViewDate, _topSafeAreaMode = param.topSafeAreaMode, topSafeAreaMode = _topSafeAreaMode === void 0 ? "padding" : _topSafeAreaMode, _sticky = param.sticky, sticky = _sticky === void 0 ? true : _sticky;
    var ref = (0,_components_common_Badge__WEBPACK_IMPORTED_MODULE_4__/* .useBadgePresets */ .fw)(), newbadge = ref.new;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.u)();
    var randomNum = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return Math.floor(Math.random() * (50 - 20) + 20);
    }, []);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isShowRandomNumber = ref1[0], setIsShowRandomNumber = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var lastDate = lastPeekTabViewDate ? new Date(lastPeekTabViewDate) : undefined;
        if (lastDate) {
            lastDate === null || lastDate === void 0 ? void 0 : lastDate.setHours((lastDate === null || lastDate === void 0 ? void 0 : lastDate.getHours()) + 6);
        }
        var now = new Date();
        var isShowRandomNumber = activeTab !== "home_peek" && (!lastDate || (0,date_fns__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(now, lastDate));
        setIsShowRandomNumber(isShowRandomNumber);
    }, []);
    if (type === "badge") {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
            css: badgeTabWrapperCSS(fit, hideBorder),
            className: "".concat(className, " ").concat(activeTab),
            children: tabs.map(function(tab) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_common_Badge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                    className: "tab-badge ".concat(tab.value === activeTab ? "active-tab-badge" : "unactivate-tab-badge"),
                    text: tab.value,
                    onClick: function() {
                        return onChange === null || onChange === void 0 ? void 0 : onChange(tab.value);
                    },
                    backgroundColor: tab.value === activeTab ? theme.colors.main500 : theme.true.white,
                    color: tab.value === activeTab ? theme.true.white : theme.true.black,
                    radius: 5,
                    fontSize: 14
                });
            })
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        css: tabWrapperCSS(fit, stickyAt, hideBorder, topSafeAreaMode, sticky),
        className: className,
        children: tabs.map(function(tab) {
            if (tab.value === "chat-library") {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("button", {
                    css: tabCSS(tab.value === activeTab, fit),
                    onClick: function() {
                        return onChange === null || onChange === void 0 ? void 0 : onChange(tab.value);
                    },
                    children: [
                        tab.label,
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_common_Badge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, _objectSpreadProps(_objectSpread({
                            text: "N"
                        }, newbadge), {
                            css: badgeCSS
                        }))
                    ]
                }, "tab-".concat(tab.label));
            }
            if (tab.value === "home_peek") {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("button", {
                        className: "peek-tab",
                        css: tabCSS(tab.value === activeTab, fit),
                        onClick: function() {
                            return onChange === null || onChange === void 0 ? void 0 : onChange(tab.value);
                        },
                        children: [
                            tab.label,
                            isShowRandomNumber && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_common_Badge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, _objectSpreadProps(_objectSpread({
                                text: "".concat(randomNum)
                            }, newbadge), {
                                css: dateBadgeCSS
                            }))
                        ]
                    })
                }, "tab-".concat(tab.label));
            }
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("button", {
                css: tabCSS(tab.value == activeTab, fit),
                onClick: function() {
                    return onChange === null || onChange === void 0 ? void 0 : onChange(tab.value);
                },
                children: tab.label
            }, "tab-".concat(tab.label));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Tab);
var useTab = function(tabs) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        replace: false,
        withoutReRendering: false,
        refresh: false,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClickTab: function() {}
    };
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var isMounted = (0,_hooks_useMounted__WEBPACK_IMPORTED_MODULE_2__/* .useMounted */ .s)();
    var replace = options.replace, withoutReRendering = options.withoutReRendering;
    var currentTab = router.query.tab;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(undefined), lastPeekTabViewDate = ref[0], setLastPeekTabViewDate = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(currentTab || tabs[0].value), activeTab = ref1[0], setActiveTab = ref1[1];
    var onChange = function(tab) {
        var ref;
        options === null || options === void 0 ? void 0 : (ref = options.onClickTab) === null || ref === void 0 ? void 0 : ref.call(options, tab);
        if (tab === "home_peek") {
            var date = new Date();
            setLastPeekTabViewDate(date);
            _utils_localStorage__WEBPACK_IMPORTED_MODULE_6__/* .ParsedStorage.setItem */ .f.setItem("lastPeekTabViewDate", date);
        }
        if ((options === null || options === void 0 ? void 0 : options.refresh) && tab === activeTab) {
            return window.location.reload();
        }
        (0,react__WEBPACK_IMPORTED_MODULE_1__.startTransition)(function() {
            setActiveTab(tab);
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isMounted) {
            return;
        }
        if (activeTab && replace && !withoutReRendering) {
            router.replace({
                query: _objectSpreadProps(_objectSpread({}, router.query), {
                    tab: activeTab
                })
            }, undefined, {
                shallow: true,
                scroll: false
            });
        } else if (withoutReRendering) {
            (0,_utils_query__WEBPACK_IMPORTED_MODULE_7__/* .changeQueryWithoutRendering */ .Gu)(_objectSpreadProps(_objectSpread({}, router.query), {
                tab: activeTab
            }));
        }
    }, [
        activeTab
    ]);
    return {
        tabs: tabs,
        activeTab: activeTab,
        onChange: onChange,
        lastPeekTabViewDate: lastPeekTabViewDate,
        setLastPeekTabViewDate: setLastPeekTabViewDate
    };
};


/***/ })

}]);